import React, { useContext } from 'react';
import { AppContext } from '@thd-nucleus/app-render';
import { string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useLocation } from '@thd-olt-component-react/router';
import { useConfigService, useStore } from '@thd-nucleus/experience-context';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { ExpandedBrowseAndSearch } from './ExpandedBrowseAndSearch';
import { BrowseAndSearch } from './BrowseAndSearch';
import {
  getContentfulPreviewCustomerType,
  getContentfulPreviewPathName
} from './browse-and-search-utils';

const browseDefaultVariables = {
  skipInstallServices: false,
  skipSpecificationGroup: false
};

const searchOptsFn = ({ options, queryName }) => {
  if (queryName === 'searchStreamProduct') {
    const variables = options.variables;
    // eslint-disable-next-line no-param-reassign
    options.variables = undefined;
  }
  return options;
};

const searchSkipFn = ({ skip, queryName, attributes }) => {
  if (queryName === 'searchStreamProduct') {
    if (!attributes?.searchModel?.products?._children?.fulfillment) return true;
  }
  return skip;
};

export const BrowseAndSearchContainer = (props) => {
  const isBuyitagainEnabled = useConfigService('fs-prop:isBuyitagainEnabled');
  const { isCustomerIdentified = false } = useThdCustomer();
  const store = useStore();
  const { isLocalized, membershipInformation } = store || {};

  if (browseDefaultVariables) {
    browseDefaultVariables.skipBuyitagain = !isBuyitagainEnabled;
    browseDefaultVariables.isBrandPricingPolicyCompliant = isLocalized ? isCustomerIdentified : false;
    browseDefaultVariables.dynamicHydration = 'true';
    browseDefaultVariables.dynamicHydrationPageSize = 24;
    browseDefaultVariables.loyaltyMembershipInput = membershipInformation?.data?.loyaltyMembership;
  }

  const { pageType } = props;
  const { pathname } = useLocation();
  const { instance } = useContext(AppContext);
  let customerType = instance?.customer?.type;
  const isDiscoveryZonesEnabled = useConfigService('fs-prop:isDiscoveryZonesEnabled');
  const isDiscoveryZonesSearchEnabled = useConfigService('fs-prop:isDiscoveryZonesSearchEnabled');
  const isPlpExpansionEnabled = true;// useConfigService('fs-prop:isPlpExpansionEnabled');

  const isSearch = pageType === 'search';
  const shouldEnableExpandedPage = isSearch && isPlpExpansionEnabled;

  browseDefaultVariables.skipDiscoveryZones = !(isDiscoveryZonesEnabled && pageType === 'browse')
    && !(isDiscoveryZonesSearchEnabled && pageType === 'search');

  // --this is specific for being able to render pages for Contentful's previews
  const previewLink = instance?.headers?.['x-content-preview'];
  let finalPathname = pathname;
  if (previewLink) {
    finalPathname = getContentfulPreviewPathName(pathname);
    customerType = getContentfulPreviewCustomerType(pathname);
  }

  if (pageType === 'browse') {
    return (
      <>
        { shouldEnableExpandedPage
          ? (

            <QueryProvider
              cacheKey="browse-search-browse-expanded"
              defaultVariables={browseDefaultVariables}
              queryOptions={searchOptsFn}
              skip={searchSkipFn}
            >
              <ExpandedBrowseAndSearch
                pathname={finalPathname}
                customerType={customerType}
                instance={instance}
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                {...props}
              />
            </QueryProvider>
          )
          : (
            <QueryProvider
              cacheKey="browse-search-browse"
              defaultVariables={browseDefaultVariables}
              queryOptions={searchOptsFn}
              skip={searchSkipFn}
            >
              <BrowseAndSearch
                pathname={finalPathname}
                customerType={customerType}
                instance={instance}
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                {...props}
              />
            </QueryProvider>
          )}
      </>
    );
  }

  return (
    <>
      { shouldEnableExpandedPage
        ? (
          <QueryProvider
            cacheKey="browse-search-desktop-expanded"
            defaultVariables={browseDefaultVariables}
            forceClientQueriesOnServer={['searchModel', 'product']}
          >
            <ExpandedBrowseAndSearch
              pathname={finalPathname}
              customerType={customerType}
              instance={instance}
              /* eslint-disable-next-line react/jsx-props-no-spreading */
              {...props}
            />
          </QueryProvider>
        )
        : (
          <QueryProvider
            cacheKey="browse-search-desktop"
            defaultVariables={browseDefaultVariables}
            forceClientQueriesOnServer={['searchModel', 'product']}
          >
            <BrowseAndSearch
              pathname={finalPathname}
              customerType={customerType}
              instance={instance}
              /* eslint-disable-next-line react/jsx-props-no-spreading */
              {...props}
            />
          </QueryProvider>
        )}
    </>
  );

};

BrowseAndSearchContainer.propTypes = {
  pageType: string.isRequired
};